import { getGlobalDebuggerObject, getTopFrameRule, isTopLevel, upsertGlobalDebuggerObject } from './window';
import { ENABLER } from './constants';
import { getParamValue } from './url';
import { log } from './log';
import { getInternalConfig } from './index';
const getDebuggerRule = () => {
    var _a;
    const paramValue = getParamValue(ENABLER);
    if (paramValue) {
        return paramValue;
    }
    const topFrameRule = getTopFrameRule();
    if (topFrameRule) {
        return topFrameRule;
    }
    try {
        const localStorageRule = ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(ENABLER)) || '';
        if (localStorageRule) {
            return localStorageRule;
        }
    }
    catch (error) {
        log(getInternalConfig(), 'warn', undefined, JSON.stringify(error));
    }
    return '';
};
/**
 * Finds component name in provided string and decides whether to log based on it.
 * @param {String | null} paramValue Value of debug UTM
 * @param {*} name Name of current library
 * @return {Boolean} Should log or not
 */
const findNameInValue = (paramValue, name) => {
    // empty string, or any falsey
    if (!paramValue) {
        return false;
    }
    // if paramValue === "1" always log
    if (paramValue === '1') {
        return true;
    }
    // if paramValue contains "!" allowed libraries are defined by exclusion
    if (~paramValue.indexOf('!')) {
        if (~paramValue.toLowerCase().indexOf(`!${name.toLowerCase()}`)) {
            return false;
        }
        return true;
    }
    // if paramValue isn't "1" and contains name - should log
    if (~paramValue.toLowerCase().indexOf(name.toLowerCase())) {
        return true;
    }
    // did not fit any category - should NOT log
    return false;
};
/**
 * Decides whether current library should be logging.
 * @param {*} name Name of current library
 * @return {Boolean} Should log or not
 */
const getShouldLog = (name) => {
    var _a;
    const rule = getDebuggerRule();
    if (!((_a = getGlobalDebuggerObject()) === null || _a === void 0 ? void 0 : _a.welcomeNotified) && rule && isTopLevel()) {
        upsertGlobalDebuggerObject({ welcomeNotified: true });
        log(getInternalConfig(), 'log', undefined, '===============================================\n' +
            ` | 🕷 DEBUGGER is set to "${rule}".\n` +
            ` | Use "1" to let any component log or use component name[s] to filter them.\n` +
            ` | Using \"!component\" lets log all components except those listed.\n` +
            ` | Save the rule to local storage using GET parameter "?sznivadbgsave=${rule}"\n` +
            ` | and remove it by "?sznivadbgsave=".\n` +
            ` \`=======================================================`);
    }
    return findNameInValue(rule, name);
};
export { findNameInValue, getShouldLog, getDebuggerRule };
